module.exports = __webpack_public_path__ + "img/Auth Manage.45b85b9e.svg";